import { render, staticRenderFns } from "./EducationInfoAdd.vue?vue&type=template&id=0be64bac"
import script from "./EducationInfoAdd.vue?vue&type=script&lang=js"
export * from "./EducationInfoAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports